// FieldMapping.js (Enhanced UI + Add Field Support)
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';

export default function FieldMapping() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const fileName = state?.fileName || 'Unknown File';
  const headers = state?.mockHeaders || ['First Name', 'Last Name', 'Email', 'Phone', 'Address'];
  const sampleData = state?.sampleData || [];

  const defaultSystemFields = [
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
  ];

  const [systemFields, setSystemFields] = useState(defaultSystemFields);
  const [mapping, setMapping] = useState({});

  const handleSelect = (sysKey, csvHeader) => {
    setMapping(prev => ({ ...prev, [sysKey]: csvHeader }));
  };

  const handleAddField = () => {
    const idx = systemFields.length - defaultSystemFields.length + 1;
    const leftKey = `custom_left_${idx}`;
    const rightKey = `custom_right_${idx}`;
    setSystemFields(prev => [
      ...prev,
      { key: leftKey, label: `Custom Field Left ${idx}` },
      { key: rightKey, label: `Custom Field Right ${idx}` }
    ]);
  };

  const handleNext = () => {
    navigate('/template-designer', {
      state: {
        mapping,
        headers,
        sampleData,
        systemFields,
        fileName
      }
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-stone-50 to-amber-50">
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-slate-800 mb-6">Field Mapping for: <span className="text-amber-600">{fileName}</span></h1>

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-slate-700">Map Fields to CSV Columns</h2>
          <button
            onClick={handleAddField}
            className="text-sm bg-slate-800 text-white px-4 py-1.5 rounded-full shadow hover:bg-slate-900"
          >+ Add Field</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {systemFields.map((field, index) => (
            <div key={field.key} className="bg-white p-4 rounded-lg shadow border border-slate-200">
              <label className="block mb-2 font-medium text-slate-700">{field.label}</label>
              <select
                className="w-full border rounded px-3 py-2"
                value={mapping[field.key] || ''}
                onChange={e => handleSelect(field.key, e.target.value)}
              >
                <option value="">-- Select CSV Column --</option>
                {headers.map(header => (
                  <option key={header} value={header}>{header}</option>
                ))}
              </select>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={handleNext}
            className="bg-gradient-to-r from-slate-800 to-amber-600 text-white px-8 py-3 rounded-full hover:from-slate-900 hover:to-amber-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl font-medium"
          >
            Next: Design Template
          </button>
        </div>
      </div>
    </div>
  );
}
